/** Per-mode step colors (Quick → Deep Dive), sampled by mode position. */
export const COMPOSER_MODE_GLOWS = ["#F9B45C", "#E02615"];

/** Accent dot / thumb color for the active mode. */
export const COMPOSER_MODE_ACCENT = "#F56B10";

/** The accent color as an `r,g,b` triple, for composing rgba() strings. */
export const COMPOSER_MODE_ACCENT_RGB = "245,107,16";

/** Track gradient across the slider, warming from Quick to Deep Dive. */
export const COMPOSER_MODE_GRADIENT =
  "linear-gradient(90deg, #F9B45C 0%, #F56B10 55%, #D93A1E 100%)";

/** Warm gradient wrapped around the composer edge band on Deep Dive. */
export const COMPOSER_MODE_EDGE_GRADIENT =
  "conic-gradient(from 0deg, rgba(249,180,92,0.18), rgba(245,107,16,0.2) 25%, rgba(249,180,92,0.18) 50%, rgba(245,107,16,0.2) 75%, rgba(249,180,92,0.18) 100%)";

/** Pick the color from a ramp at a fraction (0..1) of its length. */
export const sampleRamp = (ramp: string[], fraction: number): string =>
  ramp[Math.round(fraction * (ramp.length - 1))] ?? ramp[ramp.length - 1];
